import type { Result } from '../../types/result';
import type Lead from '../../types/leadDelivery';
import { fetchQualifiedResults } from './fetchQualifiedResults';

type FetchDuplicateProgramsParams = {
  lead: Lead;
  degree?: string;
  category?: string;
  subject?: string;
  presentationUrl?: string;
  forceLinkoutSchoolIds?: number[];
  schoolId: number;
  excludeProgramIds?: number[];
  limit?: number;
  qualified?: string[];
  unqualified?: string[];
};

const fetchDuplicatePrograms = async ({
  lead,
  degree,
  category,
  subject,
  presentationUrl,
  forceLinkoutSchoolIds,
  schoolId,
  excludeProgramIds,
  limit,
  qualified,
  unqualified,
}: FetchDuplicateProgramsParams): Promise<Result[]> => {
  if (!schoolId) {
    throw new Error('schoolId is required to fetch duplicate programs');
  }

  const data = await fetchQualifiedResults({
    lead,
    degree,
    category,
    subject,
    presentationUrl,
    forceLinkoutSchoolIds,
    schoolIds: [schoolId],
    excludeProgramIds,
    limit,
    exactOnly: true,
    qualified,
    unqualified,
  });

  return data.exactResults;
};

export default fetchDuplicatePrograms;
